import { isPhrasingContent, isPresentationalPhrasingContent } from '../dom/content';
import { simplifyElement } from '../dom/element';
import { isHTMLOrSVGElement } from '../dom/node';
import { paintNodesInRange } from '../dom/paint';
import { getComputedStyle } from './computedStyle';

export function nodeIsItalic(node: Node, container: Node): boolean {
  const style = getComputedStyle(node, container);

  return !!style && computedStyleIsItalic(style);
}

export function computedStyleIsItalic(computedStyle: CSSStyleDeclaration): boolean {
  return styleIsItalic(computedStyle);
}

export function styleIsItalic(style: CSSStyleDeclaration): boolean {
  return fontStyleIsItalic(style.fontStyle);
}

export function fontStyleIsItalic(fontStyle: string | null): boolean {
  return fontStyle === 'italic';
}

export function clearItalicInElement(element: HTMLElement | SVGElement) {
  // eslint-disable-next-line no-param-reassign
  element.style.fontStyle = '';
}

export function clearItalicInRange(container: Node, range: Range): Range {
  return paintNodesInRange(container, range, {
    shouldPaintNode: node => nodeIsItalic(node, container),
    shouldSplitElement: element => isPresentationalPhrasingContent(element),
    paintElement: element => {
      let shouldSimplify = ['I', 'EM'].includes(element.tagName);

      if (isHTMLOrSVGElement(element) && fontStyleIsItalic(element.style.fontStyle)) {
        shouldSimplify = shouldSimplify || element.tagName === 'SPAN';

        clearItalicInElement(element);
      }

      if (shouldSimplify) {
        return simplifyElement(element);
      }

      return element;
    },
  });
}

export function setItalicInElement(element: HTMLElement | SVGElement) {
  // eslint-disable-next-line no-param-reassign
  element.style.fontStyle = 'italic';
}

export function setItalicInRange(container: Node, range: Range): Range {
  return paintNodesInRange(container, range, {
    shouldPaintNode: node => isPhrasingContent(node) && !nodeIsItalic(node, container),
    createPaintedElement: document => document.createElement('i'),
    paintElement: element => {
      if (isHTMLOrSVGElement(element)) {
        setItalicInElement(element);
      }

      return element;
    },
    forcePaintElement: element => {
      if (isHTMLOrSVGElement(element)) {
        // eslint-disable-next-line no-param-reassign
        element.style.fontStyle = 'italic !important';
      }

      return element;
    },
  });
}
